<template>
  <collapse-portlet title="Organisation Switcher" icon="la la-building" :expanded="false">
    <div class="row">
      <div class="col-12">
        <div class="alert alert-ss-danger" role="alert">
          <div class="alert-icon">
            <i class="flaticon-warning" />
          </div>
          <div class="alert-text">
            Switching a customers organisation can be damaging. Be certain before doing so.
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 mb-4">
        <multiselect v-if="available_organisations && available_organisations.length"
                     v-model="selected_organisation"
                     :options="available_organisations"
                     label="name"
                     placeholder="Select Target Organisation"
                     track-by="uuid" />
      </div>
    </div>

    <div v-if="canShowOrganisationSwitcher" class="row">
      <div class="col-12 col-md-6">
        <div class="card w-100">
          <div class="card-header kt-font-boldest">
            Current Organisation : {{ customer_with_organisation.organisation.name }}
          </div>
          <div class="card-body">
            <p><strong>Customers In This Organisation</strong></p>
            <hr>
            <p v-for="customer in customer_with_organisation.organisation.customers" :key="customer.uuid">
              <span v-if="customer.uuid === customer_with_organisation.uuid">{{ customer.name }} (current)</span>
              <span v-else>{{ customer.name }}</span>
            </p>
            <p><strong>Customer Users</strong></p>
            <hr>
            <p v-for="user in customer_with_organisation.users" :key="user.uuid">
              {{ user.name }} ({{ user.email }})
            </p>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="card w-100">
          <div class="card-header kt-font-boldest">
            Target Organisation : {{ selected_organisation ? selected_organisation.name : "Not Selected" }}
          </div>
          <div v-if="selected_organisation && selected_organisation.customers" class="card-body">
            <p><strong>Customers In This Organisation</strong></p>
            <hr>
            <p v-for="customer in selected_organisation.customers" :key="customer.uuid">
              <span>{{ customer.name }}</span>
            </p>
          </div>
        </div>
      </div>
      <div v-show="selected_organisation && selected_organisation.uuid" class="col-12">
        <div class="alert alert-warning mt-4 mb-4" role="alert">
          Switching a customers organisation will result in all users being removed from the customer.
          This is because users cannot belong to multiple organisations. If this is going to be a problem for you please
          discuss with development.
        </div>
        <button type="button"
                class="btn btn-ss"
                @click="confirmOrgSwitch">
          Switch Organisation
        </button>
      </div>
    </div>
    <password-confirm-modal :name="pwd_modal_name" />
  </collapse-portlet>
</template>

<script>
import PasswordConfirmModal from 'VueModals/PasswordConfirmModal';
import CollapsePortlet from "VueComponents/CollapsePortlet";

export default {
  components: {
    CollapsePortlet,
    PasswordConfirmModal,
  },
  props: {
    customerWithOrganisation: {
      type: Object,
      required: true,
    },
    organisations: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      selected_organisation: null,
      available_organisations: [],
      pwd_modal_name: `pwd-confirm`,
      customer_with_organisation: this.customerWithOrganisation,
    };
  },
  computed: {
    canShowOrganisationSwitcher() {
      return this.available_organisations
        && this.available_organisations.length
        && this.customer_with_organisation
        && this.customer_with_organisation.organisation;
    },
    organisationSwitchPostData() {
      if (this.selected_organisation) {
        return { organisation_uuid: this.selected_organisation.uuid };
      }
      return null;
    },
  },
  beforeMount() {
    this.setupOrganisations();
  },
  mounted() {
    if (this.organisations) {
      this.available_organisations = this.organisations;
    }

    EventBus.$on('password-confirmed-and-proceed-success', (payload) => {
      this.selected_organisation = null;
      this.customer_with_organisation = payload;
      toastr.success("Organisation Changed");
    });

    EventBus.$on('password-confirmed-and-proceed-error', (payload) => {
      window.handleAxiosError(payload);
    });
  },
  methods: {
    setupOrganisations() {
      if (!this.organisations || !this.organisations.length) {
        axios.get('/api/v1/admin/organisation').then((response) => {
          this.available_organisations = response.data.data;
        }).catch((error) => {
          window.handleAxiosError(error);
        });
      } else {
        this.available_organisations = this.organisation_users;
      }
    },
    async confirmOrgSwitch() {
      const res = await this.fireModal(this.pwd_modal_name);
      if (res.data.success) {
        try {
          await axios.post(
            `/api/v1/admin/customer/${this.customer_with_organisation.uuid}/switch-organisation`,
            {
              ...this.organisationSwitchPostData,
              password: res.data.password,
            },
          );
          toastr.success(`Organisation changed`);
        } catch (err) {
          console.error(err);
          window.handleAxiosError(err);
        }
      }
    },
  },
};
</script>
